<script src="./app.js"></script>
<style scoped src="@/component.css"></style>

<template>
  <div id="app" :class="typeof weatherMiyazaki.main != 'undefined' && weatherMiyazaki.weather[0].main == 'Rain' ? 'rain' : 'warm'">
    <main>
      <div class="search-box">
        <input
          type="text"
          class="search-bar"
          placeholder="Search..."
          v-model="query"
          @keypress="fetchWeather"
        />
      </div>

      <div
        :style="{
          display: 'flex',
          alignContent: 'space-between',
          justifyContent: 'space-evenly',
        }"
      >
        <!-- Dhaka weather view -->
        <div
          class="weather-wrap"
          v-if="typeof weatherDhaka.main != 'undefined'"
          :class="
            typeof weatherDhaka.main != 'undefined' &&
            weatherDhaka.main.temp > 16
              ? 'warm'
              : ''
          "
        >
          <div class="location-box">
            <div class="location">
              {{ weatherDhaka.name }}, {{ weatherDhaka.sys.country }}
            </div>
            <div class="date">{{ timeBuilder() }}</div>
            <div class="date">{{ dateBuilder() }}</div>
          </div>

          <div class="weather-box">
            <div class="temp">
              <div :style="{fontSize: '102px'}">{{ Math.round(weatherDhaka.main.temp) }}°c</div>
              <div :style="{fontSize: '70px'}">{{ Math.round(weatherDhaka.main.temp * (9.0/5.0) + 32.0) }}°F</div>
            </div>
            <div class="weather">{{ weatherDhaka.weather[0].main }}</div>
          </div>
          
          <div :style="{textAlign: '-webkit-center'}">
            <table>
              <tbody>
                <tr>
                  <td>Feels Like</td>
                  <td>{{weatherDhaka.main.feels_like}}</td>
                </tr>
                <tr>
                  <td>Humidity</td>
                  <td>{{weatherDhaka.main.humidity}}</td>
                </tr>
                <tr>
                  <td>Pressure</td>
                  <td>{{weatherDhaka.main.pressure}}</td>
                </tr>
                <tr>
                  <td>Wind</td>
                  <td>{{weatherDhaka.wind.speed}} m/s</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- search data -->
        <div
          class="weather-wrap"
          v-if="typeof searchWeatherData.main != 'undefined'"
          :class="
            typeof searchWeatherData.main != 'undefined' &&
            searchWeatherData.main.temp > 16
              ? 'warm'
              : ''
          "
        >
          <div class="location-box">
            <div class="location">
              {{ searchWeatherData.name }}, {{ searchWeatherData.sys.country }}
            </div>
            <div class="date">{{ searchTime }}</div>
            <div class="date">{{ dateBuilder() }}</div>
          </div>

          <div class="weather-box">
            <div class="temp">
              <div :style="{fontSize: '102px'}">{{ Math.round(searchWeatherData.main.temp) }}°c</div>
              <div :style="{fontSize: '70px'}">{{ Math.round(searchWeatherData.main.temp * (9.0/5.0) + 32.0) }}°F</div>  
            </div>
            <div class="weather">{{ searchWeatherData.weather[0].main }}</div>
          </div>
          
          <div :style="{textAlign: '-webkit-center'}">
            <table>
              <tbody>
                <tr>
                  <td>Feels Like</td>
                  <td>{{searchWeatherData.main.feels_like}}</td>
                </tr>
                <tr>
                  <td>Humidity</td>
                  <td>{{searchWeatherData.main.humidity}}</td>
                </tr>
                <tr>
                  <td>Pressure</td>
                  <td>{{searchWeatherData.main.pressure}}</td>
                </tr>
                <tr>
                  <td>Wind</td>
                  <td>{{searchWeatherData.wind.speed}} m/s</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- Miyazaki weather view -->
        <div
          class="weather-wrap"
          v-if="typeof weatherMiyazaki.main != 'undefined'"
          :class="typeof weatherMiyazaki.main != 'undefined' && weatherMiyazaki.main.temp > 16 ? 'warm' : ''"
        >
          <div class="location-box">
          <div class="location" :style="{fontSize:'150%'}">
              {{ weatherMiyazaki.name }}、日本
            </div>
            <div class="date" :style="{fontSize:'100%'}">{{ jpTimeBuilder() }}</div>
            <div class="date" :style="{fontSize:'100%'}">{{ jpDateBuilder() }}</div>
          </div>

          <div class="weather-box">
            <div lass="weather-box" class="temp">
              <div :style="{fontSize: '102px'}">{{ Math.round(weatherMiyazaki.main.temp) }}°c</div>
              <div :style="{fontSize: '70px'}">{{ Math.round(weatherMiyazaki.main.temp * (9.0/5.0) + 32.0) }}°F</div>
            </div>

            <div class="weather" :style="{fontSize:'220%'}">
              <!-- <div class="weather-icon">
                let urlStr = "http://openweathermap.org/img/w/" + weatherMiyazaki.weather[0].icon + ".png"
                <a href="#" id="mylink">My Link</a>
                var id = weatherMiyazaki.weather[0].icon
                var url = "http://openweathermap.org/img/w/"+id+".png";

                document.getElementById("mylink").href = url;
              </div>  -->
              {{ weatherMiyazaki.weather[0].description }}
            </div>
          </div>

          <div :style="{textAlign: '-webkit-center', fontSize:'80%'}">
            <table>
              <tbody>
                <tr>
                  <td>感じる</td>
                  <td>{{weatherMiyazaki.main.feels_like}}</td>
                </tr>
                <tr>
                  <td>湿度</td>
                  <td>{{weatherMiyazaki.main.humidity}}</td>
                </tr>
                <tr>
                  <td>プレッシャー</td>
                  <td>{{weatherMiyazaki.main.pressure}}</td>
                </tr>
                <tr>
                  <td>風</td>
                  <td>{{weatherMiyazaki.wind.speed}} m/s</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
